import { InsurersCodeEnum } from '../../../../enums/insurers-code.enum';

export interface SyncBatchNumberingInput {
  status: string;
  itemCount: number;
  quotationCode?: string | null;
  insurerCode?: string | null;
}

export interface SyncBatchNumberingEligibility {
  allowed: boolean;
  reason?: string;
}

export function canSyncBatchNumbering(
  batch: SyncBatchNumberingInput,
): SyncBatchNumberingEligibility {
  if (batch.insurerCode && batch.insurerCode !== InsurersCodeEnum.Yelum) {
    return {
      allowed: false,
      reason: 'Sincronização de numeração disponível apenas para lotes Yelum.',
    };
  }

  if (batch.status === 'CANCELLED') {
    return {
      allowed: false,
      reason: 'Não é possível sincronizar numeração de lote cancelado.',
    };
  }

  if (!batch.quotationCode?.includes('-')) {
    return {
      allowed: false,
      reason: 'Lote sem código de cotação Yelum válido para sincronização.',
    };
  }

  if (batch.itemCount === 0) {
    return {
      allowed: false,
      reason: 'Lote sem itens ativos para sincronizar numeração.',
    };
  }

  return { allowed: true };
}
